import React, { useState, useRef, useEffect } from 'react';
import { Button, PagingQuery } from 'tea-component';
import { history, getLocale } from 'umi';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { useIntl } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getCountryFlag } from '@/pages/home/_config/countries';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  GenreHeader,
  GenreRender,
} from '@/pages/intelligence/components/TableComponents/components/TableGenre';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import DataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-bg.svg';
import { DatabrainBubbleContent } from '@/pages/home/pages/home/components/DataSource';
import TableNodata from '@/pages/intelligence/pages/Following/components/TableNodata';
import { LANGUAGE_CN } from '@home/_config/config';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
interface NewReleaseTableProps extends TopchartTableProps {
  entityType: string;
  APPID: string;
  onClickNodata: Function;
}

export default function NewReleasePCConsoleTable(props: NewReleaseTableProps) {
  const {
    APPID,
    className,
    entityType,
    loading,
    records = [],
    tableTotal,
    pageSortAttr,
    onTableSortChage,
    onTablePagingChange,
    tableSelection,
    tableSelectionAll,
    onTableCheckGame,
    onClickNodata,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const { tablePageIndex, tablePageSize, currentSortValue, currentSortMetric } = pageSortAttr || {};
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;
  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  const onClickGame = (gameId: string) => {
    history.push(getDetailGameOverviewPath(gameId, entityType));
  };

  return (
    <>
      {/* 如果没有排序 header-other 用个类名 有排序用这个 table-header */}
      {/* sub-table-fixed 子表格固定的类名 组件库修改 全局通用 */}
      <TopchartTable
        className="dbi-table-sticky"
        recordKey={APPID}
        loading={loading}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        nodataDom={<TableNodata onClickNodata={onClickNodata} />}
        columns={[
          {
            key: 'select',
            width: 36,
            fixed: 'left',
            header: () => {
              return (
                <TableCheckboxHeader
                  selectList={selectList}
                  tableSelectionAll={tableSelectionAll}
                  disabled={loading || records?.length === 0}
                  onChange={(list, stats) => {
                    onTableCheckGame(list, stats);
                    setSelectList(list);
                  }}
                />
              );
            },
            render: (cvm: any) => {
              return (
                <TableCheckboxRender
                  selectList={selectList}
                  cvm={{ ...(cvm || {}), gameId: cvm?.[APPID] }}
                  onChange={(list, status) => {
                    setSelectList(list);
                    onTableCheckGame(list, status);
                  }}
                />
              );
            },
          },
          {
            key: 'gametitle',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <div>{formatMessage({ id: 'dbi_top_gametitle' })}</div>
              </div>
            ),
            width: 330,
            fixed: 'left',
            render: (cvm: any) => {
              // const icons = cvm?.platform?.map((t: string) => {
              //   const src = t === 'ps' ? 'playstation' : t;
              //   return getImg(src);
              // });
              return (
                <FirstRow
                  id={cvm?.rank}
                  cvm={{
                    imgType: entityType,
                    img: cvm?.cover,
                    gametitle: cvm?.name,
                    countryIcon: getCountryFlag(cvm?.markets),
                    text: cvm?.publisher,
                    // icon: entityType === 'pc' ? null : icons,
                  }}
                  rihgtClickToJumpHref={getDetailGameOverviewPath(cvm?.[APPID], entityType)}
                  onClick={() => {
                    onClickGame(cvm?.[APPID]);
                  }}
                />
              );
            },
          },
          // PHeatColumn({
          //   currentSortKey: currentSortMetric,
          //   currentSortValue: currentSortValue,
          //   onSortChage,
          // }),
          {
            key: 'potential',
            width: 150,
            align: 'center',
            header: () => {
              /**当不是环比排序时，表格标题文本有提示文本 */
              return (
                <CloumsCenter width={150} align={'left'}>
                  <SortBy
                    title={formatMessage({ id: `dbi_top_pheat` })}
                    defaultKey={currentSortMetric}
                    defaultValue={currentSortValue}
                    svgIcon={DataBrainIcon}
                    align={'left'}
                    list={[
                      {
                        key: 'potential',
                        sortMetric: 'potential',
                        text: formatMessage({ id: `dbi_top_pheat` }),
                        title: formatMessage({ id: `dbi_top_pheat` }),
                      },
                    ]}
                    onChange={onSortChage}
                    svgTip={
                      <DatabrainBubbleContent sourceNameLocalId={'P.Heat'} metric={'databarin'} />
                    }
                    content={<p>{formatMessage({ id: `dbi_info_newgames_pheat` })}</p>}
                  />
                </CloumsCenter>
              );
            },
            render: (cvm: any) => {
              return (
                <CloumsCenter width={150} align={'left'}>
                  {cvm?.metric_list?.find((item) => item?.metric === 'potential')?.value}
                </CloumsCenter>
              );
            },
          },
          {
            key: 'release_time',
            align: 'center',
            width: 170,
            header: (
              <CloumsCenter width={170} align="left">
                <div className="header-other">{formatMessage({ id: 'dbi_release_date' })}</div>
              </CloumsCenter>
            ),
            render: (cvm: any) => {
              const releaseTime = formatReleaseTime(locale, {
                isSpecialReleaseTime: cvm?.is_special_release_time,
                releaseTime: cvm?.release_time,
                releaseTimeEN: cvm?.release_time_en,
                releaseTimeCN: cvm?.release_time_cn,
              });
              return (
                <CloumsCenter width={170} align="left">
                  {releaseTime || '-'}
                </CloumsCenter>
              );
            },
          },
          {
            key: 'genre',
            header: (
              <div className="header-other">
                <GenreHeader genreSource={''} />
              </div>
            ),
            width: 220,
            align: 'left',
            render: (cvm: any) => {
              return <GenreRender mainGenre={cvm?.genre || '-'} subGenre={cvm?.sub_genre || '-'} />;
            },
          },
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.[APPID]);
            },
            formatMessage,
          }),
        ]}
      />
    </>
  );
}
